<div class="py-10 d-flex align-center column-gap-10">
  <img src="assets/icons/alert-{{ data.type }}.svg" alt="" />
  <span class="font-{{ data.type }} font-size-12 line-height-18 font-regular">{{
    data.message
  }}</span>
</div>
